.fp-slider(data-test='carousel' @mouseenter='enter' @mouseleave='leave' @touchstart='onTouchStart' @touchend='onTouchEnd')
  slot
